export default __webpack_public_path__ + "static/media/1.56926659.jpg";